import PAButton, { BUTTON_TYPE } from "component/design-system/buttons/PAButton";
import PAImage from "component/design-system/images/PAImage";
import PAText, { FONT_SIZE } from "component/design-system/typography/PAText/PAText";
import SafeLink from "modules/components/SafeLink";
import { useTranslation } from "next-i18next";
import { getRelativeImagePath } from "util/helper/getRelativeImagePath";
import HideIf from "util/HideIf";
import { getHrefAndPath } from "util/url/getHrefAndPath";
import commonStyles from "./commonStyles.module.scss";
import styles from "./table.module.scss";

function Table(props: any) {
  const {
    table, buttonTitle, rowBorder = false, className = "",
    noBorder = false,
  } = props;
  const { t } = useTranslation("static-pages");
  const { href, asPath } = getHrefAndPath({ asPath: "/replacement-parts" });

  return (
    <div className={`${styles.max_width} ${className}`}>
      <PAText component="h2" fontSize={FONT_SIZE[5]} centerAlign bold color="black" className={`m-t-0 m-b-15 ${styles.font_size_big} `}>
        {t(table.heading)}
      </PAText>
      <table className={`${styles.table} ${styles.column_width} ${rowBorder ? styles.row_border : ""} ${noBorder ? styles.no_border : ""} `}>

        <thead>

          <tr>
            {table.rows[0].map((eachRow) => {
              const {
                type, src = "", data = "", alt = "", color = "transparent",
              } = eachRow;

              if (type === "image") {
                return <th key={src} className={styles[color]} aria-label={alt}><PAImage height="calc(5 * var(--safari-root-font, 10px))" src={getRelativeImagePath(`/cms/${src}`)} /></th>;
              }
              if (type === "string") {
                return <th key={data} className={styles[color]} aria-label={alt}>{t(data)}</th>;
              }
              return null;
            })}
          </tr>
        </thead>

        <tbody>
          {table.rows.map((eachRow, index) => index !== 0 && (
            <tr key={index}>
              {eachRow.map((eachData) => {
                const {
                  data, color, type, src, url, text,
                } = eachData;

                if (type === "boolean") {
                  if (src) {
                    return (
                      <td key={src} className={styles[color]} aria-label={data ? "tick" : "cross"}>
                        <PAImage height="calc(3 * var(--safari-root-font, 10px))" src={getRelativeImagePath(`/cms/${src}`)} />
                      </td>
                    );
                  }
                  if (text) {
                    return (
                      <td key={src} className={styles[color]} aria-label={data ? "tick" : "cross"}>
                        <span className={styles.bool_text}>
                          {t(text)}
                        </span>
                      </td>
                    );
                  }

                  return (
                    <td key={src} className={styles[color]} aria-label={data ? "tick" : "cross"}>
                      <i className={`fa fa-times ${styles.bool_icon}`} />
                    </td>
                  );
                }

                return (

                  <td key={data} className={styles[color || "transparent"]}>
                    <HideIf show={url}>
                      <SafeLink href={url} target="_blank">
                        {t(data)}
                      </SafeLink>
                    </HideIf>

                    <HideIf show={!url}>
                      {t(data)}
                    </HideIf>

                  </td>

                );
              })}
            </tr>
          ))}

        </tbody>
      </table>
      {props.children}
      <HideIf show={buttonTitle}>
        <div className="d-flex align-items-center justify-content-center m-t-30">
          <SafeLink href={href} asPath={asPath}>
            <PAButton buttonType={BUTTON_TYPE.SECONDRY} className={commonStyles.button_style}>
              {t(buttonTitle)}
            </PAButton>
          </SafeLink>

        </div>
      </HideIf>

    </div>
  );
}

export default Table;
